import React from "react";
import "../Css/VideoSection.css";

const VideoSection = () => {
  return (
    <section className="video-section">
      <div className="video-container">

        {/* LEFT VIDEO */}
        <div className="video-left">
          <div className="video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/Xry80hpQzj0"
              title="IITians Chinmay Academy"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="video-right">
          <h2>A Class Apart</h2>
          <p>IITian's Chinmay Academy | Documentary</p>

          <a
            href="https://www.youtube.com/watch?v=Xry80hpQzj0"
            target="_blank"
            rel="noopener noreferrer"
            className="watch-btn"
          >
            Watch
          </a>
        </div>

      </div>
    </section>
  );
};

export default VideoSection;